import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { ChaptersDeleteData } from '../../../types/chapters'
import { useApiPostMutation } from '../useApi'

export const useChaptersDelete = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, ChaptersDeleteData>()

  return {
    ...mutation,
    mutateAsync: async (data: ChaptersDeleteData) => {
      const result = await mutation.mutateAsync({
        url: '/chapters/delete',
        data,
      })
      queryClient.invalidateQueries({ queryKey: ['chapterList'] })
      return result
    },
    mutate: (data: ChaptersDeleteData) => {
      mutation.mutate(
        {
          url: '/chapters/delete',
          data,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['chapterList'] })
          },
        }
      )
    },
  }
}
